export default __webpack_public_path__ + "static/media/SVK.21b8d961.svg";